var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"type":"info","prominent":"","border":"left","text":"","dismissible":""}},[_vm._v(" "+_vm._s(_vm.$t('patientPortal.invoices.unavailable'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }